module.exports = __webpack_public_path__ + "static/portfolio-1-cc4f838955e214c8bd2d802cbae090a0.jpg";